import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";
import { errorLog } from "./logger";

export const vibrateDevice = async () => {
  // Haptics requires the browser to support window.navigator.vibrate
  if (Capacitor.getPlatform() === "web" && (!window.navigator || !window.navigator.vibrate)) {
    return;
  }

  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch (e: any) {
    try {
      await Haptics.vibrate({ duration: 50 });
    } catch (fallbackError: any) {
      errorLog(fallbackError);
    }
  }
};

/**
 * XXX: The very first call to `vibrateDevice()` in the Capacitor app incurs a bit of delay and can
 * even stutter the UI. I have no idea why this is happening, but this function exposes a
 * workaround. It calls the Haptics vibrate with a duration so small that it doesn't seem to
 * register on the device as an actual vibration. The idea is to call this once, when a core
 * component mounts. Afterwards, any call to `vibrateDevice()` will not incur a delay.
 */
export const kickoffHaptics = async () => {
  if (Capacitor.getPlatform() === "web") {
    return;
  }
  try {
    // RIP - you can't use 0 as a duration because 0 is falsy and the lib uses
    // `const duration = options?.duration || 300`
    await Haptics.vibrate({ duration: 1 });
  } catch (fallbackError: any) {
    errorLog(fallbackError);
  }
};
